export enum ScalarExpr {
  Bin = 'BIN',
}
